import { adminRoot } from './config'

const data = [
  {
    id: 'categories',
    icon: 'simple-icon-layers',
    label: 'menu.categories',
    to: `${adminRoot}/categories`
  },
  {
    id: 'Links',
    icon: 'simple-icon-layers',
    label: 'menu.links',
    to: `${adminRoot}/links`
  },
  {
    id: 'products',
    icon: 'iconsminds-bag-items',
    label: 'menu.products',
    to: `${adminRoot}/products`
  },
  {
    id: 'product-sections',
    icon: 'iconsminds-box-with-folders',
    label: 'menu.product-sections',
    to: `${adminRoot}/product-sections`
  },
  {
    id: 'manufacturers',
    icon: 'iconsminds-power-station',
    label: 'menu.manufacturers',
    to: `${adminRoot}/manufacturers`
  },
  {
    id: 'sliders',
    icon: 'iconsminds-photo-album-2',
    label: 'menu.sliders',
    to: `${adminRoot}/sliders`
  },
  {
    id: 'hit-products',
    icon: 'iconsminds-magic-wand',
    label: 'menu.hit-products',
    to: `${adminRoot}/hit-products`
  },
  {
    id: 'faq',
    icon: 'iconsminds-speach-bubble-asking',
    label: 'menu.faq',
    to: `${adminRoot}/faq`
  },
  {
    id: 'options',
    icon: 'iconsminds-gear',
    label: 'menu.options',
    to: `${adminRoot}/options`
  },
  {
    id: 'delivery-terms',
    icon: 'iconsminds-scooter',
    label: 'menu.delivery-terms',
    to: `${adminRoot}/delivery-terms`
  },
  {
    id: 'districts',
    icon: 'iconsminds-district',
    label: 'menu.districts',
    to: `${adminRoot}/districts`
  },
  {
    id: 'payment-terms',
    icon: 'iconsminds-credit-card-3',
    label: 'menu.payment-terms',
    to: `${adminRoot}/payment-terms`
  },
  {
    id: 'pages',
    icon: 'iconsminds-digital-drawing',
    label: 'menu.pages',
    to: `${adminRoot}/pages`
  },
  {
    id: 'promocodes',
    icon: 'iconsminds-coins-2',
    label: 'menu.promocodes',
    to: `${adminRoot}/promocodes`
  },
  {
    id: 'orders',
    icon: 'iconsminds-cart-quantity',
    label: 'menu.orders',
    to: `${adminRoot}/orders`
  },
  {
    id: 'callback',
    icon: 'iconsminds-telephone-2',
    label: 'menu.callback',
    to: `${adminRoot}/callback`
  }
]
export default data
